export const selectToken = state => state.auth.token;
export const selectPersonalInfo = state => state.auth.personalInfo;
export const selectPersonalId = state => state.auth.personalInfo.id;
export const selectUserPermissions = state => state.auth.personalInfo?.permissions || {};
export const selectUserType = state => state.auth.personalInfo?.type;
export const selectUserRoles = state => state.auth.personalInfo?.roles || [];
export const selectUserAccessByLicense = state => state.auth.personalInfo?.accessByLicence || [];
